<template>
    <div style="width:100%;heigh:100%;" id='inventory-records'>
        <div class="table_searchbar">
            <el-row :gutter="W?20:0">
                <el-col :span="span">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">盘点日期：</span>
                        <el-date-picker style="width:180px;"
                            @change='dateChange'
                            v-model="searchForm.date"
                            value-format='yyyy-MM'
                            type="monthrange"
                            range-separator="-"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份">
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :span="span">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">盘点人员：</span>
                        <el-select size="small" style="max-width:180px;" v-model="searchForm.userId" placeholder="盘点人员" filterable >
                            <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="W?span:6">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">盘点状态：</span>
                        <el-select size="small" style="max-width:180px;" v-model="searchForm.isConfirm" placeholder="盘点状态" filterable >
                            <el-option key="0" label="已平库存" :value="true"></el-option>
                            <el-option key="1" label="未平库存" :value="false"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="W?(24-3*span):4">
                    <div style="text-align:right">
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-table @sort-change='sortChangeEvent' :default-sort='defaultSort' :data="tableData" stripe style="width: 100%" class="deviceTable">
            <el-table-column prop="warehouseName" label="盘点仓库" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userName" label="盘点人员"  min-width="110"></el-table-column>
            <el-table-column sortable="custom" prop="gmtCreate" label="创建时间" :formatter='parseDate' min-width="110"></el-table-column>
            <el-table-column sortable="custom" prop="submitTime" label="盘点时间" :formatter='parseModified' min-width="110"></el-table-column>
            <el-table-column prop="isConfirm" sortable="custom" label="盘点状态"  :formatter='parseStatus' min-width="110">
                <template slot-scope="scope">
                    <span :style="{color:parseStyle(scope.row)}">{{parseStatus(scope.row)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="140" v-if="permission.btn_inventoryOfStock_list">
                <template slot-scope="scope">
                    <el-button type="text" @click="showViewDialog(scope.row)" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page" v-if="tableData.length > 0">
            <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
            <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                </el-pagination>
            </div>
        </div>

        <!-- 查看点检点检开始 -->
        <el-dialog title="盘点详情" @close="cancelViewDialog"  :visible.sync="viewDialogVisible" :width="span==5?'48%':'68%'" center :close-on-click-modal="false">
            <el-form  style="width:100%;" class="add_form">
                <el-table @selection-change="selecChange" :data="detailList"  style="width: 100%;margin-bottom:10px;" empty-text='盘点无出入' >
                    <el-table-column label="序号" min-width="60">
                        <template slot-scope="scope">
                                <span>{{scope.$index+1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="materialCode" label="物料编码" min-width="110">
                    </el-table-column>
                    <el-table-column prop="productionBatch" label="批次"  min-width="110">
                    </el-table-column>
                    <el-table-column label="所在仓库" prop="warehouseName" min-width="110" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column v-if="isConfirm" label="盘点前数量" prop="beforeConfirmAmount"  min-width="110">
                        <template slot-scope="scope">
                            <span>{{scope.row.beforeConfirmAmount}}{{scope.row.unitOfQuantity}}</span>
                        </template>
                    </el-table-column>
                     <el-table-column v-if="isConfirm" label="盘点后数量" prop="afterConfirmAmount"  min-width="110">
                         <template slot-scope="scope">
                            <span>{{scope.row.afterConfirmAmount}}{{scope.row.unitOfQuantity}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="差额" prop="gap"  min-width="110">
                       <template slot-scope="scope">
                            <span>{{scope.row.gap}}{{scope.row.unitOfQuantity}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" prop="remark"  min-width="140">
                    </el-table-column>
                    <el-table-column :key="Math.random()" v-if="!isConfirm"  type="selection" width="55" fixed="right"></el-table-column>
                </el-table>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="permission.btn_stockCounting_confirm&&!isConfirm" @click="confirmGap" type="primary">平库存</el-button>
                <el-button v-if="isConfirm" type="primary"  @click="cancelViewDialog">确 定</el-button>
                <el-button v-else  @click="cancelViewDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 新增点检配置结束 -->
    </div>
</template>

<script>

export default {
    name: 'InventoryRecords',
	data () {
        return {
            fristLoad:false,
            userList:[],
            isConfirm:null,
            selectId:null,
            selectData:[],
            detailList:[],
            viewDialogVisible:false,
            W:false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm:{
                startTime:null,
                endTime:null,
                userId:null,
                date:null,
                isConfirm:null,
            },
            tableData:[
            ],
            tableCurrentPage:1,
            tableTotalPage:2,
            viewDialogVisible:false,
            data: {
				token: localStorage.getItem("token"),
            },
            permission:JSON.parse(localStorage.getItem("permission")),
            orderType:'DESC',
            orderColumn:'gmtCreate',//排序列
            defaultSort: {prop: 'gmtCreate', order: 'descending'},//默认排序设置
        }
    },
    mounted:function(){
        this.initTable();
        this.loadUlserList()
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    deactivated:function(){
        console.log("deactivated");
    },
    methods:{
        parseStyle(rowData){
            if(rowData.isConfirm != null){
                let str = ''
                if(rowData.isConfirm){
                    str = 'green'
                }else{
                    str = 'red'
                }
                return str
            }
        },
        sortChangeEvent(param){
            let orderType = param.order;
            let orderColumn = param.prop;
            this.orderColumn = orderColumn;
            if(orderType == 'descending'){
                this.orderType = 'DESC';
            }else if(orderType == 'ascending'){
                this.orderType = 'ASC';
            }else{
                this.orderType = orderType;
                this.orderColumn = null
            }

            this.search(1);
            this.tableCurrentPage = 1
        },
        loadUlserList(){
            this.$RequestUtil.get({
				url: '/api/select/listWorker',
                params: {
                    noFilterDeparture:1
                },
                type:'sync',
				success: (res) => {
					if(res.code == 0){
                        this.userList = res.data;
					}
				}
			});
        },
        dateChange(ev){
            if(ev){
                this.searchForm.startTime = ev[0]
                this.searchForm.endTime = ev[1]
            }else{
                this.searchForm.startTime = null
                this.searchForm.endTime = null
            }
        },
        selecChange(ev){
            this.selectData = ev
        },
        cancelViewDialog(){
            this.viewDialogVisible = false
            this.detailList = []
            this.selectData = []
            this.selectId=null
            this.isConfirm=null
        },
        sumitGap(){
            let gapList = []
            this.selectData.forEach(item=>{
                gapList.push(item.id)
            })
            this.$RequestUtil.post({
                url: '/api/recordOfStockCounting/confirmGap',
                type:'sync',
                params: {
                    gapList,
                    recordOfStockCountingId:this.selectId
                },
                success:res=>{
                    if(res.code==0){
                        this.$message.success('操作成功')
                        this.cancelViewDialog()
                        this.initTable();
                    }else{
                        this.$message.error(res.msg||res.message);

                    }
                }
            })
        },
        confirmGap(){
            if(this.selectData.length==0){
                this.$confirm(' 您尚未勾选任何记录，是否确认操作?', '提示', {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sumitGap()
                })
            }else{
                this.sumitGap()
            }
        },
        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },
        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.startTime=null
            form.endTime=null
            form.userId=null
            form.date=null
            form.isConfirm=null
        },
        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                    startTime:null,
                    endTime:null,
                    userId:null,
                    date:null,
                    isConfirm:null,
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            this.$RequestUtil.post({
                url: '/api/recordOfStockCounting/listGap',
                type:'sync',
				params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    materialCode : temp.materialCode,
                    startTime:temp.startTime,
                    endTime:temp.endTime,
                    userId:temp.userId,
                    date:temp.date,
                    isConfirm:temp.isConfirm,
                    orderColumn:this.orderColumn,
                    orderType:this.orderType
                },
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },
        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },
        initTable:function(){
            this.search();
        },
        async showViewDialog(rowData){
            this.isConfirm = rowData.isConfirm
            let data = await this.loadRecordsDetail(rowData.id)
            this.detailList = data
            this.viewDialogVisible = true;
            this.selectId = rowData.id
        },
        async loadRecordsDetail(id){
            let res = await this.$RequestUtil.postAsync({ url: '/api/inventoryOfStockCounting/listGapDetail',type:'sync',params: {recordOfStockCountingId:id}})
            return res.data
        },
        parseDate:function(rowData){
            if(rowData.gmtCreate != null){
                let dateString = commonUtils.timestampToDate(rowData.gmtCreate);
                return dateString;
            }
        },
        parseModified(rowData){
            if(rowData.submitTime != null){
                let dateString = commonUtils.timestampToDate(rowData.submitTime);
                return dateString;
            }
        },
        parseStatus(rowData){
            if(rowData.isConfirm != null){
                let str = ''
                if(rowData.isConfirm){
                    str = '已平库存'
                }else{
                    str = '未平库存'
                }
                return str
            }
        },
    }
}
</script>

<style scoped>

.table_searchbar .title11{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.add_form .title{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display:inline-block;
    text-align: right;
    width: 70px;
}
.add_form .value{
    display:inline-block
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.table_searchbar{
    width:100%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1450px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
</style>
<style>
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
#inventory-records .el-table th>.cell{
  padding-left: 14px!important;
}
</style>




// WEBPACK FOOTER //
// src/views/stock/InventoryRecords.vue